<template>
     <div class="topdiv">
        <p class="main_title">我的协议</p>
        <Table class="mytableframe" :no-data-text="nodatatxt" :columns="columns" :data="data" width="100%"  v-cloak height="740">
            <template slot-scope="{ row }" slot="action">
                <Button size="small" @click="lookRow(row)" style="margin-right: 10px" type="primary">查看协议</Button>
                <!-- <Button size="small" @click="printRow(row)" type="error">打印协议</Button> -->
            </template>
        </Table>
        <Member ref="mymember_agreement" :isPrinter="true" />
        <VIP ref="myvip_agreement" :isPrinter="true" />
        <NewProduct ref="mynewproduct_agreement" :isPrinter="true" />
    </div>
</template>
<script>
import MemberAgreement from './product_agreement.vue'
import VIPAgreement from './product_package_agreement.vue'
import newProductAgreement from './new_product_agreement.vue'
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    data() {
        return {
            nodatatxt:"<img src='/resource/images/nodata.png' style='height:\'98px;\' width=\'66px;\'' />",
            data: [],
            columns: [{
                    title: '订单号',
                    key: 'orderid',
                    //minWidth: 350

                },
                {
                    title: '名称',
                    key: 'product_desc',
                    //minWidth: 355

                },
                {
                    title: '金额',
                    key: 'actualamount',
                    //minWidth: 250

                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: 200
                }
            ]
        }
    },
    components: {
        'Member': MemberAgreement,
        'VIP': VIPAgreement,
        'NewProduct': newProductAgreement,
        //'Printer':PrintView,
    },
    created() {
        this.show()
    },
    methods: {
        //获取合同信息
        // const (
        // PAYSTATUS_WAITINGPAY PayStatus = 0
        // PAYSTATUS_TIMEOUT    PayStatus = -200
        // PAYSTATUS_PAYEND     PayStatus = 100
        // PAYSTATUS_CANCELLED  PayStatus = -99
        // )
        getOrderContract(row) {
            let isShowSignDate = false
            //獲取合同信息
            console.log('查看合同orderid:' + row.orderid)
            constJ.reqGetOrderContract(row.orderid).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //this.showQRAndCheckPayStatus()
                    //会员等级订单

                    if (row.mall_ver === 'v1') {

                        if (row.ordertype === 10 || row.ordertype === 11) {
                            if (row.paystatus === 100) {
                                isShowSignDate = true
                                this.$refs.mymember_agreement.showImg = true
                            }
                            this.$refs.mymember_agreement.createdata(res.item, isShowSignDate)
                            this.$refs.mymember_agreement.show()
                            //vip升级权限订单
                        } else if (row.ordertype === 20) {
                            if (row.paystatus === 100) {
                                isShowSignDate = true
                                this.$refs.myvip_agreement.showImg = true
                            }
                            this.$refs.myvip_agreement.createdata(res.item, isShowSignDate)
                            this.$refs.myvip_agreement.show()
                        }
                    } else {
                        //v2
                        if (row.ordertype === 10 || row.ordertype === 11 || row.ordertype === 801 ) {
                            if (row.paystatus === 100) {
                                isShowSignDate = true
                                this.$refs.mynewproduct_agreement.showImg = true
                            }
                            this.$refs.mynewproduct_agreement.createdata(res.item, isShowSignDate)
                            this.$refs.mynewproduct_agreement.show()
                        }
                    }

                    // let clock = window.setInterval(() => {
                    //     let c = this.$refs.mymember_agreement.getPrintContent()
                    //     //console.log(c)
                    //     this.printHtml=c
                    //    //this.setBodyHtml(c)
                    //     window.clearInterval(clock)
                    // }, 5000)

                    // let c = this.$refs.mymember_agreement.getPrintContent()
                    // this.printHtml=c


                }
            })
        },
        // 查看
        lookRow(row) {
            this.getOrderContract(row)
            console.log(row);
        },
        // 打印
        printRow(row) {
            console.log(row);
        },
        show() {
            constJ.reqGetOrderContractList().then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    if (res.items) {
                        this.data = res.items
                    } else {
                        this.data = []
                    }
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.topdiv{
    background:#fff;
    padding: 5px;
    width:98%;
    margin:0 auto;
}

.main_title{
height: 20px;
font-size: 20px;
font-family: Source Han Sans CN;
font-weight: bold;
color: #2D2F33;
margin-bottom: 30px;
padding-left: 10px;
}


.mytableframe/deep/tr{
    height: 50px;
}
</style>